const rootActionPath = 'core/HomeValueBanner';

export const HOME_VALUE_BANNER_VIEW = `${rootActionPath}/VIEW`;
